import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';
import { Movie } from '../../services/Page/page.service';
import { FeaturedCardComponent } from "../featured-card/featured-card.component";

@Component({
    selector: 'app-featured-list',
    imports: [
    CommonModule,
    SafeHtmlPipe,
    FeaturedCardComponent
],
    templateUrl: './featured-list.component.html',
    styleUrl: './featured-list.component.scss'
})
export class FeaturedListComponent {
    @Input('title') title: string = ''
    @Input('movies') movies: Movie[] = []
}
